import React from "react";
import { useParams } from "react-router-dom";
import { setMatchGreenCards } from '../../../api/setMatchGreenCards';
import { getRoundMatches } from '../../../api/getRoundMatches';

import styles from "./GreenCardForm.module.css";

function GreenCardForm(props) {
  const { teamId, setMatches } = props;
  const { leagueId, roundId, matchId } = useParams();

  const [cards, setCards] = React.useState(0);

  React.useEffect(() => {
    setCards(0);
  }, [teamId]);

  const handleSubmit = async () => {
    const res = await setMatchGreenCards(
      leagueId,
      roundId,
      matchId,
      teamId,
      parseInt(cards, 10)
    );

    if (!res.error) {
      const res2 = await getRoundMatches(leagueId, roundId);
      if (!res2.error) {
        setMatches(res2);
      }
    }
  };

  return (
    <div className={styles.greenCardForm}>
      <h3>כמה כרטיסים ירוקים הקבוצה קיבלה</h3>
      <form>
        <input
          type="number"
          value={cards}
          onChange={(e) => setCards(e.target.value)}
        />
        <button onClick={handleSubmit} type="button" className="btnLarge">
          שליחת כרטיס ירוק
        </button>
      </form>
    </div>
  );
}

export default GreenCardForm;
